import { Box as BasicBox } from '../../../../Components/Base';

const BoxView = () => {
  return <BasicBox width={300} height={300} bgcolor={'primary.dark'} />;
};

export default BoxView;
